import { List, ListItem } from '@astryxdesign/core/List';
import { Text } from '@astryxdesign/core/Text';
import { CaretRight } from '@phosphor-icons/react';
import type { Studio } from '@/api/schemas';
import { EmptyView } from '@/components/StateViews';
import { fmtDuration, fmtMoney } from '@/lib/format';

export function ServiceStep({ studio, onChoose }: { studio: Studio; onChoose: (id: string) => void }) {
  if (studio.services.length === 0) {
    return <EmptyView title="Услуги скоро появятся" description={`Запишитесь по телефону ${studio.settings.phone}`} />;
  }
  return (
    <List hasDividers density="spacious" header={<Text type="label">Что делаем?</Text>}>
      {studio.services.map((s) => (
        <ListItem
          key={s.id}
          label={s.name}
          description={`${fmtDuration(s.durationMin)} · ${fmtMoney(s.priceCents, studio.currency, s.priceIsFrom)}`}
          endContent={<CaretRight size={18} aria-hidden />}
          onClick={() => onChoose(s.id)}
        />
      ))}
    </List>
  );
}
